<script>
import PincodeInput from 'vue-pincode-input'

export default {
  name: 'BaseInputPincode',
  components: {
    PincodeInput,
  },
  props: {
    modelValue: {
      type: String,
      required: true,
    },
    otpLength: {
      type: Number,
      default: 6,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['complete', 'update:modelValue'],
  computed: {
    otpCode: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', value)
      },
    },
    shouldFillSlash() {
      return this.otpCode?.length >= 3
    },
  },
  watch: {
    otpCode(newVal) {
      if (newVal?.length === this.otpLength) {
        this.$emit('complete', { otp: newVal })
      }
    },
  },
}
</script>

<template>
  <div class="tamara-base-input-pincode__container">
    <div
      class="tamara-base-input-pincode__wrapper"
      :class="{ 'filled-slash': shouldFillSlash }"
    >
      <div dir="ltr" class="tamara-base-input-pincode">
        <PincodeInput
          v-model="otpCode"
          :length="otpLength"
          :disabled="disabled"
          placeholder="0"
        />
        <div class="tamara-base-input-pincode__slash">
          -
        </div>
      </div>
    </div>
    <Transition name="fade">
      <div v-if="errorMessage" class="tamara-base-input-pincode__error">
        <svg-icon
          icon-class="warning-circle-lavender"
          width="24px"
          height="24px"
        />
        <span>{{ errorMessage }}</span>
      </div>
    </Transition>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';
@import '@/styles/_breakpoints.scss';

.tamara-base-input-pincode {
  --tamara-otp-slash-color: #949abf66;

  display: flex;
  justify-content: center;

  &__container {
    position: relative;
    display: flex;
    justify-content: center;
    width: 100%;
  }

  &__wrapper {
    position: relative;
    display: block;
    width: fit-content;

    &.filled-slash {
      .tamara-base-input-pincode__slash {
        --tamara-otp-slash-color: var(--tamara-color-functional-grey-dark-2);
      }
    }
  }

  &__slash {
    @extend .tamara-display-medium;

    position: absolute;
    top: 0;
    left: 87px;
    width: 16px;
    height: 100%;
    color: var(--tamara-otp-slash-color);
  }

  &::v-deep .vue-pincode-input-wrapper {
    .vue-pincode-input {
      @extend .tamara-display-medium;

      width: 26px;
      max-width: 26px;
      padding: 0;
      margin: 0;
      font-family: 'Space Grotesk', sans-serif !important;
      color: var(--tamara-color-functional-grey-dark-2);
      background-color: transparent;
      border: none;
      box-shadow: none;

      &::placeholder {
        color: #949abf66;
      }

      &:nth-child(3) {
        margin-right: 34px;
      }
    }
  }

  &__error {
    @extend .tamara-body-medium;

    position: absolute;
    bottom: -16px;
    left: 0;
    display: flex;
    gap: 8px;
    align-items: center;
    color: var(--tamara-color-error);

    [dir='rtl'] & {
      right: 0;
      left: unset;
    }
  }
}
</style>
